import type { CatalogueProduct } from 'src/graphql/generated';

const sortFeatures = (
  features: CatalogueProduct['features'],
): CatalogueProduct['features'] =>
  features.slice().sort((a, b) => (a && b ? a.id.localeCompare(b.id) : 1));

export const isEqualProductFeatures = (
  baseFeatures: CatalogueProduct['features'],
  compareFeatures: CatalogueProduct['features'] | undefined,
  isEnabled = false, // This feature toggle has been done because of JPU-1874
): boolean => {
  if (!isEnabled) {
    return false;
  }
  // If the arrays are of different lengths, they are not identical
  if (!compareFeatures || baseFeatures.length !== compareFeatures.length) {
    return false;
  }

  // Sort both arrays to ensure that the objects are compared in the correct order
  const sortedBaseFeatures = sortFeatures(baseFeatures);
  const sortedCompareFeatures = sortFeatures(compareFeatures);

  // Iterate through the sorted arrays and compare each object
  for (let i = 0; i < sortedBaseFeatures.length; i++) {
    const baseFeature = sortedBaseFeatures[i];
    const compareFeature = sortedCompareFeatures[i];

    // Compare based on "id"
    if (baseFeature?.id !== compareFeature?.id) {
      return false;
    }
  }

  // If all objects are identical, the arrays are identical
  return true;
};
